const carriersOrder = ["0", "1", "2", "4"];

export default carriersOrder;
